import {GenreStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/GenreStaticLandingPageVo.interface';
import {
  StaticLandingGenreParamInput,
  StaticLandingGenreSectionParam,
} from '../generated/types';
import {createSortOption} from './SortOption';

export function createStaticLandingGenreSectionParam(
  vo: GenreStaticLandingPageVo,
  input: StaticLandingGenreParamInput
): StaticLandingGenreSectionParam {
  return {
    categoryUid: input.categoryUid,
    subcategory: vo.selected_subcat_opt
      ? createSortOption({sortOptVo: vo.selected_subcat_opt})
      : undefined,
    sortType: vo.selected_sort_opt
      ? createSortOption({
          sortOptVo: vo.selected_sort_opt,
        })
      : undefined,
    page: input.page,
    isComplete: input.isComplete,
    screenUid: input.screenUid,
  };
}
